module.exports = "/assets/24a0e9eb8dc682b1df0050b43ca87682.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VB.png
// module id = 3039
// module chunks = 0